exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customBlocksTabsContainer[data-v-3dc91b04]{margin-top:20px;margin-bottom:20px;border-bottom:1px solid #dee2e6!important}.customBlocksTabsContainer .blocks-tabs[data-v-3dc91b04]{margin-top:0;margin-bottom:0;border-bottom:none!important}.customBlocksTabsContainer .blocks-tabs p a.active[data-v-3dc91b04]{background-color:#d4d4d4}.remove-field-btn[data-v-3dc91b04]{right:-15px;top:40px}h6 .fa-plus-circle[data-v-3dc91b04]{color:#00c851}h6 .fa-trash-alt[data-v-3dc91b04]{color:#c05621}", ""]);

// exports
